import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {BASE_URL} from "../api";

export const filterApi = createApi({
    reducerPath: 'filterApi',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL }
    ),
    endpoints: (builder) => ({
        getFilter: builder.query({
            query: (language) => ({
                url: `/filter`,
                headers: {
                    "accept-language": language
                },
            }),
        })
    }),
});

export const { useGetFilterQuery } = filterApi;

